import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../contexts/AuthContext';
import { ledgerService } from '../services/api';

const Dashboard = () => {
  const { currentUser, logout } = useAuth();
  const [balance, setBalance] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      try {
        const res = await ledgerService.getAccount();
        setBalance(res.data?.balance_hours ?? 0);
      } catch (e) {
        setError('Errore nel recupero del saldo ore');
      }
    };
    load();
  }, []);

  const handleLogout = () => logout();

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
      <div className="lg:order-3 lg:col-span-3">
        <div className="card">
          <div className="card-body text-center">
            <a
              href="https://www.comune.poggioreale.tp.it/homepage.html"
              target="_blank"
              rel="noopener noreferrer"
              className="mx-auto flex flex-col items-center no-underline"
            >
              <img src="/logogcomune.png" alt="Logo Comune" className="h-36 w-36 object-contain" />
              <div className="mt-2 text-base font-bold text-slate-900">Comune di Poggioreale</div>
              <div className="text-sm font-medium text-slate-600">Libero Consorzio Comunale di Trapani</div>
            </a>
            <div className="mt-4 text-sm text-slate-600">
              <div className="leading-relaxed">
                Via Ximenes, 1 · CAP 91020
                <br />
                Poggioreale (TP)
              </div>

              <div className="mt-4 grid gap-3">
                <div className="space-y-1">
                  <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Telefono</div>
                  <div className="font-medium text-slate-700">0924 75777</div>
                </div>
                <div className="space-y-1">
                  <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Mail</div>
                  <div className="break-all font-medium text-slate-700">bancadeltempo@comune.poggioreale.tp.it</div>
                </div>
                <div className="space-y-1">
                  <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">PEC</div>
                  <div className="break-all font-medium text-slate-700">comunepoggioreale@pec.it</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:order-1 lg:col-span-3">
        <div className="card">
          <div className="card-body text-center">
            <img src="/logoservizisociali.png" alt="Servizi sociali" className="mx-auto h-44 w-44 object-contain" />
            <div className="mt-3 space-y-1 text-sm text-slate-600">
              <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">Email</div>
              <div className="break-all font-medium text-slate-700">servizisociali@comune.poggioreale.tp.it</div>
            </div>
          </div>
        </div>
      </div>

      <div className="lg:order-2 lg:col-span-6">
        <div className="card">
          <div className="card-body">
            <h1 className="text-2xl font-bold text-slate-900 sm:text-3xl">Dashboard Banca del Tempo</h1>
            <p className="mt-2 text-base font-medium text-slate-700">
              Benvenuto, {currentUser?.first_name} {currentUser?.last_name}!
            </p>

            {error ? <div className="alert-error mt-4">{error}</div> : null}

            <div className="mt-5 grid gap-3 sm:grid-cols-2">
              <div className="rounded-2xl border border-slate-200 bg-white/60 p-4">
                <div className="text-xs font-bold uppercase tracking-wide text-slate-500">Saldo ore</div>
                <div className="mt-1 text-2xl font-bold text-slate-900">{balance ?? '—'} h</div>
              </div>
              <div className="rounded-2xl border border-slate-200 bg-white/60 p-4">
                <div className="text-xs font-bold uppercase tracking-wide text-slate-500">Ruolo</div>
                <div className="mt-1 text-base font-bold text-slate-900">
                  {currentUser?.role === 'superadmin'
                    ? 'Super Amministratore'
                    : currentUser?.role === 'admin'
                      ? 'Amministratore'
                      : currentUser?.role === 'moderator'
                        ? 'Moderatore'
                        : 'Utente'}
                </div>
              </div>
            </div>

            <div className="mt-5">
              <Link to="/regolamento" className="btn-outline inline-flex">
                Regolamento Utente
              </Link>
            </div>

            <p className="mt-4 text-sm text-slate-600">
              Questa è la dashboard della Banca del Tempo. Da qui potrai gestire le tue attività, visualizzare il tuo saldo ore e interagire con gli altri utenti.
            </p>

            {(currentUser?.role === 'admin' || currentUser?.role === 'moderator' || currentUser?.role === 'superadmin') ? (
              <div className="mt-6">
                <div className="text-sm font-bold text-slate-900">Funzionalità di amministrazione</div>
                <div className="mt-3 grid gap-2 sm:grid-cols-3">
                  <Link to="/admin/requests" className="btn-primary w-full">
                    Gestione Richieste
                  </Link>
                  <Link to="/admin/users" className="btn-primary w-full">
                    Gestione Utenti
                  </Link>
                  <Link to="/admin/categories" className="btn-outline w-full">
                    Gestione Categorie
                  </Link>
                </div>
              </div>
            ) : null}

            <div className="mt-6 grid gap-4 sm:grid-cols-2">
              <div className="rounded-2xl border border-slate-200 bg-white/60 p-4">
                <div className="text-sm font-bold text-slate-900">Le tue abilità</div>
                <div className="mt-3">
                  <Link to="/profile/skills" className="btn-primary w-full">
                    Gestisci abilità
                  </Link>
                </div>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white/60 p-4">
                <div className="text-sm font-bold text-slate-900">Azioni rapide</div>
                <div className="mt-3">
                  <Link to="/registra-scambio" className="btn-primary w-full">
                    Registra scambio
                  </Link>
                </div>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white/60 p-4 sm:col-span-2">
                <div className="text-sm font-bold text-slate-900">Il tuo conto corrente di tempo</div>
                <div className="mt-3">
                  <Link to="/account" className="btn-primary w-full">
                    Vai al Conto Ore
                  </Link>
                </div>
              </div>
            </div>

            <button type="button" className="btn-secondary mt-6 w-full" onClick={handleLogout}>
              <LogoutIcon fontSize="small" />
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );

};

export default Dashboard;
